const ResultStatus = Object.freeze({
  PENDING: 'pending',
  APPROVED: 'approved',
})

export default ResultStatus